module.exports = __webpack_public_path__ + "img/wedcr6.9d75b7fb.jpg";